<h6 transalte="app.install.description.primary">Simple, secure, and fast!</h6>
<h6 translate="app.install.description.secondary">Get a better experience with the app.</h6>
<div class="links">
  <qrcode *ngIf="platform.is('desktop')"
          [qrdata]="qrLink"
          [ariaLabel]="'QR Code for app store'" 
          [width]="100"
          [colorDark]="'#000000'"
          [colorLight]="'#ffffff'"
          [errorCorrectionLevel]="'M'">
  </qrcode>
  <div>
    <!--
      google and apple badges:
      https://play.google.com/intl/en_us/badges/
      https://developer.apple.com/app-store/marketing/guidelines/#section-badges
    -->
    <div *ngIf="iosOrDesktop && appleStoreLink(); let link">
      <a [href]="link"
          target="_blank"
          class="badge apple"
          (click)="onTapLink($event)">
        <!-- <img src="https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2010-04-02&kind=iossoftware&bubble=ios_apps" (load)="imageLoaded($event)"/> -->
        <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us" (load)="imageLoaded($event)" alt="Download on the App Store">
        <!-- <img [src]="'/assets/icons/store/appstore_download.svg' | serverAuthUrl" (load)="imageLoaded($event)"/> -->
      </a>
    </div>
    <div *ngIf="androidOrDesktop && googlePlayLink(); let link">
      <a [href]="link"
          target="_blank"
          class="badge google"
          (click)="onTapLink($event)">
        <img src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png" (load)="imageLoaded($event)"/>
      </a>
    </div>
  </div>
</div>